import script from "./EditForecastModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditForecastModal.vue?vue&type=script&lang=ts&setup=true"

import "./EditForecastModal.vue?vue&type=style&index=0&id=51a6f55d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51a6f55d"]])

export default __exports__